import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import WaitingForConfirmationDialogImage from '../assets/imgs/profile-screen-images/waiting-for-confirmation-modal-image.svg'
import ChatUserImge from '../assets/imgs/chat-user-image.png'
import ChatIconGreen from '../assets/imgs/chat-icon-green.svg'
import ConfirmReservationModal from './ConfirmReservationModal'
import ServiceScheduledModal from './ServiceScheduledModal'
import { Link } from 'react-router-dom'
import UserImagePlaceholder from '../assets/imgs/user-image-placeholder.png'
import { Avatar } from '@mui/material'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const WaitingForConfirmationModal = ({
  waitingForConfirmationModal = false,
  handleWaitingForConfirmationModal,
  selectedService = {},
  stylist = {},
}) => {
  const [serviceScheduledModal, setServiceScheduledModal] = useState(false)
  const localStylist = JSON.parse(localStorage.getItem('stylist_profile'))
  const localService = JSON.parse(localStorage.getItem('selected_service'))
  const [service, setService] = useState({ ...selectedService })
  // if (selectedService) {
  //   setService({ ...selectedService })
  // }

  const handleServiceScheduledModal = () => {
    if (waitingForConfirmationModal === true) {
      handleWaitingForConfirmationModal(false)
    }
    setServiceScheduledModal(!serviceScheduledModal)
  }

  return (
    <>
      <Modal
        open={waitingForConfirmationModal}
        onClose={() => handleWaitingForConfirmationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center">
            <h3 className="fs-24 fw-bold mb-3">Almost there</h3>
            <img
              src={WaitingForConfirmationDialogImage}
              alt="Waiting for Confirmation Modal Image"
            />
            <p className="fs-24 color-primary my-3">Waiting for confirmation</p>
            <p className="fs-16 text-left">
              Start a conversation with your stylist
            </p>
            <div className="mt-3 d-flex gap-1">
              {localStylist?.profile_image && (
                <Avatar
                  src={localStylist?.profile_image}
                  sx={{ height: 36, width: 36 }}
                />
              )}
              {!localStylist?.profile_image && (
                <Avatar
                  src={UserImagePlaceholder}
                  sx={{ height: 36, width: 36 }}
                />
              )}
              <div className="d-flex justify-content-between align-items-center w-100">
                <div
                  className="text-left pointer"
                  onClick={handleServiceScheduledModal}
                >
                  <p className="fs-16 fw-bold">{`${localStylist?.first_name} ${localStylist?.last_name}`}</p>
                  <div className="fs-12 opacity-25">
                    Replies within 5 minutes
                  </div>
                </div>
                <Link to={'/chat'}>
                  <img src={ChatIconGreen} alt="Chat Icon" height={20} />
                </Link>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <ServiceScheduledModal
        handleServiceScheduleModal={handleServiceScheduledModal}
        serviceScheduleModal={serviceScheduledModal}
        selectedService={selectedService}
      />
    </>
  )
}

export default WaitingForConfirmationModal
